const initialState = {
  ComponentData: {
    currentNote: "",
    currentTitle: "",
    currentIndex: 0,
    showNotesList: true,
    showNotificationList: true,
    loginbtn: false
  },
  UserData: {
    name: null,
    email: null,
    isPrime: false,
    notes: [],
    notifications: [],
    more_info: {},
    fs_info: {}
  },
};

const dataReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_USER_INFORMATION":
      //  console.log("payload =>",action.payload)
      state.UserData.name = action.payload.name;
      state.UserData.email = action.payload.email;
      state.UserData.isPrime = action?.payload?.isprime || false;
      state.UserData.fs_info = action?.payload?.fs_info || null;
      state.UserData.more_info = action?.payload?.more_info || null;
      state.UserData.more_info = action?.payload;
      //    console.log("new data=> ", state)
      return state;
    case "GET_USER_INFORMATION":
      state.UserData.name = action.payload.name;
      state.UserData.email = action.payload.email;
      state.UserData.isPrime = action?.payload?.isprime || false;
      state.UserData.fs_info = action?.payload?.fs_info || null;
      state.UserData.more_info = action?.payload?.more_info || null;
      return state;
    case "GET_ALL_NOTES":
      return {
        ...state,
        UserData: {
          ...state.UserData,
          notes: action.payload
        }
      };
    case "ADD_NOTE":
      return state;
    case "DELETE_USER":
      return state;
    case "FEEDBACK":
      return state;
    case "GET_ONE_NOTE":
      return state;
    case "SET_CURRENT_NOTE":
      return state;
    case "UPDATE_NOTE":
      return state;
    case "DELETE_NOTE":
      return state;
    case "GET_USERS_NOTIFICATION":
      return {
        ...state,
        UserData: {
          ...state.UserData,
          notifications: action.payload
        }
      };
    case "DELETE_USER_NOTIFICATION":
      return { ...state };
    case "DELETE_USER_ALL_NOTIFICATION":
      return { ...state };
    case "MARKE_PRIME":
      return {
        ...state,
        UserData: {
          ...state.UserData,
          isPrime: true
        }
      };
    case "CHECK_PRIME":
      return {
        ...state,
        UserData: {
          ...state.UserData,
          isPrime: action.payload
        }
      };
    case "GET_FILES_URL":
      return {
        ...state,
        UserData: {
          ...state.UserData,
          fils_system_url: action.payload
        }
      };
    case "SET_LOGIN_BTN":
      return {
        ...state,
        ComponentData: {
          ...state.ComponentData,
          loginbtn: action.payload
        }
      };


    default:

      return state;
  }
};

export default dataReducer;
